import React from "react";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Form, Input } from "antd";
import { forgotPassword } from "../actionCreator/commonActionCreator";
import { msgEnum } from "../config";
import { useAlert } from "../context/AlertProvider";
import "../assets/css/style.css";
import AuthLeftContainer from "../common/AuthLeftContainer";
import { Button, Col, Container, Row } from "react-bootstrap";
import "../assets/css/auth.css";

const ForgetPassword = () => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const [form] = Form.useForm();
  const [generalError, setGeneralError] = React.useState();
  const [msg, setMsg] = React.useState();

  const onFinish = async (values) => {
    setGeneralError(undefined);
    setMsg(undefined);
    const { email } = values;
    const res = await dispatch(forgotPassword(email));
    if (res?.response?.status === 404) {
      showAlert("error", "No account found with this email.");
      setGeneralError("No account found with this email.");
    } else if (res?.response?.status === 400) {
      showAlert("error", res?.response?.data?.title);
      setGeneralError(res?.response?.data?.title);
    } else if (res?.status === 200) {
      setMsg(msgEnum.FORGOT_PASSWORD_MSG);
      form.resetFields();
    }
  };

  return (
    <Container
      fluid
      className="min-vh-100 h-100 p-0 text-black position-relative roboto-regular auth overflow-x-hidden"
    >
      <Row className="min-vh-100 h-100 m-0">
        <Col lg={4} className="d-none p-0 d-lg-block">
          <AuthLeftContainer />
        </Col>
        <Col xs={12} lg={8} className="p-5">
          <div className="text-right heading12px fw-semibold">
            Don’t have an account?{" "}
            <NavLink
              to="/signup"
              className="heading12px text-theme fw-semibold"
            >
              SignUp
            </NavLink>
          </div>
          <div className="d-flex flex-column auth-card justify-content-center h-100">
            <div className="login-card">
              <div className="heading20px fw-semibold pb-4 w-100 mb20">
                Forgot Password
              </div>

              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"
              >
                {generalError && (
                  <p
                    style={{
                      color: "red",
                      textAlign: "center",
                      paddingBottom: 20,
                    }}
                    className="tw-text-xs"
                  >
                    {generalError}
                  </p>
                )}

                {msg && <p className="text-error text-center tw-text-xs pb-2">{msg}</p>}

                <Form.Item
                  label={
                    <label className="heading12px text-gray pb-1">
                      Email Address
                    </label>
                  }
                  name="email"
                  rules={[
                    { required: true, message: "Please enter email." },
                    {
                      type: "email",
                      message: "Please enter valid email.",
                    },
                  ]}
                >
                  <Input
                    placeholder="E Mail Address*"
                    className="roboto-regular"
                  />
                </Form.Item>

                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                  className="theme-btn mt10"
                >
                  Submit
                </Button>
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgetPassword;
